import { Component } from 'react';
import { Spinner } from 'react-bootstrap';

interface SpinnerWithDescriptionProps {
  description: string;
}

type SpinnerWithDescriptionState = {
    waitingText: string | undefined,
}

export class SpinnerWithDescription extends Component<SpinnerWithDescriptionProps, SpinnerWithDescriptionState> {
    waitingTakesLongerTimer : NodeJS.Timeout | undefined;

    state : SpinnerWithDescriptionState = {
        waitingText: undefined, 
    }

    componentDidMount() {
        clearInterval(this.waitingTakesLongerTimer);
        this.waitingTakesLongerTimer = setInterval(() => {
            this.setState({
                waitingText: 'Waiting takes longer than expected, please have patience...',
            });

            this.waitingTakesLongerTimer = setInterval(() => {
                this.setState({
                    waitingText: 'Wow, this takes so long! Please have some more patience...',
                });

                this.waitingTakesLongerTimer = setInterval(() => {
                    this.setState({
                        waitingText: 'Still not done? Impressed by your patience...',
                    });
                }, 20000);
            }, 10000);
        }, 5000);
    }

    componentWillUnmount() {
        clearInterval(this.waitingTakesLongerTimer);
    }

    render() {
        const waitingTakesLongerRendered = this.state.waitingText ? 
            <div className="mt-3 d-flex justify-content-center">
                <p>{this.state.waitingText}</p>
            </div> : <></>


        return (
            <>
                <div className="mt-3 d-flex justify-content-center">
                    <Spinner animation="border" role="status" />
                </div>
                <div className="mt-3 d-flex justify-content-center">
                    {this.props.description}
                </div>
                {waitingTakesLongerRendered}
            </>
        );
    }
};